import { ISR, SHARED } from "@securitize/domain";
import { useEffect, useState } from "react";
import { getInvestorInformation } from "../data/rest/investorInfo";
import {
  InvestorInfo,
  InvestorInfoTax,
} from "../types/investorInformation.interface";
import useUserInfo from "./useUserInfo";
import { KycStatus } from "../types/UserInfo";

function useInvestorInfo(enabled: boolean = true) {
  const user = useUserInfo();
  const [investorInfo, setInvestorInfo] = useState<InvestorInfo | undefined>();
  const [loading, setLoading] = useState<boolean>(enabled);
  const [error, setError] = useState<boolean>(false);
  async function fetchInvestorInfo() {
    try {
      const data = await getInvestorInformation();
      setInvestorInfo(data ?? null);
    } catch{
      setError(true);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (enabled && user && investorInfo === undefined) {
      fetchInvestorInfo();
    }
  }, [enabled, user, investorInfo]);

 const isEntity = user?.investorType === ISR.InvestorTypes.ENTITY;

  const verificationStatus = user.verificationStatus;
  const  isVerified =  ![KycStatus.NOT_VERIFIED, KycStatus.REJECTED].includes(verificationStatus)


  if (
    !investorInfo
  ) {
    const initialInvestorInfo = {
      fullName: "",
      birthday: {
        date: "",
        city: "",
        country: "",
        state: "",
      },
      address: {
        street: "",
        houseNumber: "",
        entrance: "",
        city: "",
        countryCode: "",
        state: "",
        zip: "",
      },
      tax: [],
    };
    return {
      isVerified: false,
      hasUSTax: false,
      hasForeignTax: false,
      hasNoTax: true,
      isLoading: loading,
      isEntity,
      investorInfo: initialInvestorInfo,
      userInfo: user,
      error: false,
    };
  } else {
    const filteredInvestorInfo = { ...investorInfo };
    const hasUSTax =
      investorInfo.tax.filter(
        (tax: InvestorInfoTax) =>
          tax.taxCountryCode && SHARED.isUsTerritory(tax.taxCountryCode),
      ).length > 0 ;

    const hasForeignTax =
      investorInfo.tax.filter(
        (tax: InvestorInfoTax) =>
          tax.taxCountryCode && !SHARED.isUsTerritory(tax.taxCountryCode),
      ).length > 0;

    const hasNoTax = !hasUSTax && !hasForeignTax;
    return {
      isVerified,
      isLoading: loading,
      hasUSTax,
      hasNoTax,
      hasForeignTax: Boolean(hasForeignTax),
      isEntity,
      investorInfo: filteredInvestorInfo,
      userInfo: user,
      error,
    };
  }
}

export default useInvestorInfo;
